import { Controller } from "@hotwired/stimulus"

// Reveals the floating button once the page has been scrolled past the first
// screens, and smooth-scrolls back to the top on click.
export default class extends Controller<HTMLElement> {
  static classes = ["hidden", "shown"]

  declare readonly hiddenClasses: string[]
  declare readonly shownClasses: string[]

  boundToggle = this.toggle.bind(this)

  connect() {
    window.addEventListener("scroll", this.boundToggle, { passive: true })
    this.toggle()
  }

  disconnect() {
    window.removeEventListener("scroll", this.boundToggle)
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  toggle() {
    const shown = window.scrollY > 600
    this.hiddenClasses.forEach((name) => this.element.classList.toggle(name, !shown))
    this.shownClasses.forEach((name) => this.element.classList.toggle(name, shown))
  }
}
